import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";

import { StateActionTypes, StateActions } from "../../../actionTypes/master/stateActionTypes";

import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";
import { createStateApi, getStateListApi, deleteStateApi, editStateDataByIdApi, getStateDataByIdApi } from "../../requests/master/stateRequest";
import { getStateList, setStateDataById, setStateList, setStateListPageCount } from "../../../actions/master/stateActions";


function* createStateHandler(action: StateActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createStateApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getStateListHandler(action: StateActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");

    const { data } = yield call(getStateListApi, action.payload);

    if (data.status) {
      yield put(setStateList(data?.data?.rows));
      yield put(setStateListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* deleteStateHandler(action: StateActionTypes) {
  try {
    yield startLoader("transparent");

    const { data } = yield call(deleteStateApi, action.payload);

    if (data.status) {
      toast.success(data?.message, {
        position: "top-right",
      });

      // refresh zone list after delete
      yield put(getStateList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getStateDataByIdHandler(action: StateActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getStateDataByIdApi, action.payload);
    if (data.status) {
      yield put(setStateDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editStateDataByIdHandler(action: StateActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editStateDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getStateList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

// state sagas

export default function* stateSaga() {
  yield takeLatest(StateActions.CREATE_STATE, createStateHandler);
  yield takeLatest(StateActions.GET_STATE_LIST, getStateListHandler);
  yield takeLatest(StateActions.DELETE_STATE, deleteStateHandler);
  yield takeLatest(StateActions.GET_STATE_DATA_BY_ID, getStateDataByIdHandler);
  yield takeLatest(StateActions.EDIT_STATE_DATA_BY_ID, editStateDataByIdHandler);
}
